import { formatCompact } from '@betty/toolkit/utils';
import { PromotionReward } from '@betty/promos';

import { PromotionRewardTarget } from '../components/EarnRewardsSection/EarnRewardsSection.constants';

export const getLandingRewardAmount = (reward: PromotionReward) => {
  const amount = formatCompact(reward.rewardAmount ?? 0);

  return reward.rewardTarget === PromotionRewardTarget.Cash
    ? `$${amount}`
    : amount;
};
